import { Option } from "api/types/_public";

export const TYPE_SHOW_MORE_HASHTAG = {
  SCROLL: "scroll",
  MODAL: "modal",
};

export const ARR_INDEX_TEXT_DAY_OF_WEEK: string[] = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

// Status
export const ENUM_STATUS_ACTIVE_DISABLE = {
  ACTIVATE: 1,
  DISABLED: 0,
};

export const COLOR_STATUS_ACTIVE_DISABLE: any = {
  [ENUM_STATUS_ACTIVE_DISABLE.ACTIVATE]: "success",
  [ENUM_STATUS_ACTIVE_DISABLE.DISABLED]: "danger",
};

export const STATUS_ACTIVE_DISABLE_OPTION = [
  {
    label: "Active",
    value: ENUM_STATUS_ACTIVE_DISABLE.ACTIVATE,
  },
  {
    label: "Disable",
    value: ENUM_STATUS_ACTIVE_DISABLE.DISABLED,
  },
];

export const STATUS_JOB_POST_DISPLAY_STATUS_OPTION = [
  {
    label: "Show",
    value: ENUM_STATUS_ACTIVE_DISABLE.ACTIVATE,
  },
  {
    label: "Hide",
    value: ENUM_STATUS_ACTIVE_DISABLE.DISABLED,
  },
];


export const LIST_OPTION_GENDER = [
  {
    label: "Male",
    value: "MALE",
  },
  {
    label: "Female",
    value: "FEMALE",
  },
  {
    label: "Any",
    value: "ANY",
  },
];

export const LIST_OPTION_GENDER_NORMAL = [
  {
    label: "Male",
    value: "MALE",
  },
  {
    label: "Female",
    value: "FEMALE",
  }
];


export const LIST_OPTION_PLATFORM = [
  {
    label: "Platform_Google",
    value: "GOOGLE",
  },
  // {
  //   label: "Platform_Email",
  //   value: "EMAIL",
  // },
  {
    label: "Platform_Kakao",
    value: "KAKAO",
  },
  {
    label: "Platform_Apple",
    value: "APPLE",
  },
];

export const LIST_OPTION_OS = [
  {
    label: "iOS",
    value: "ios",
  },
  {
    label: "Android",
    value: "android",
  },
];

export const LIST_OPTION_ROLE = [
  {
    value: "normal",
    label: "Normal",
  },
  {
    value: "premium",
    label: "Premium",
  },
];

//notification setting
export const ENUM_NOTI_SETTING_STATUS = {
  ACTIVATED: "activated",
  DISABLED: "disabled",
};

export const NOTI_SETTING_STATUS_OPTION = [
  { label: "Activated", value: ENUM_NOTI_SETTING_STATUS.ACTIVATED },
  { label: "Disabled", value: ENUM_NOTI_SETTING_STATUS.DISABLED },
];

export const ENUM_NOTIFY_TYPE = {
  AUTO: "auto",
  MANUAL: "manual",
};

export const COLOR_NOTIFY_TYPE: any = {
  [ENUM_NOTIFY_TYPE.AUTO]: "primary",
  [ENUM_NOTIFY_TYPE.MANUAL]: "warning",
};

export const ENUM_PUSH_STATUS = {
  WAITING: "waiting",
  COMPLETED: "completed",
};

export const COLOR_PUSH_STATUS: any = {
  [ENUM_PUSH_STATUS.WAITING]: "primary",
  [ENUM_PUSH_STATUS.COMPLETED]: "success",
};

export const LIST_OPTION_PUSH_STATUS = [
  {
    value: ENUM_PUSH_STATUS.WAITING,
    label: "Waiting",
  },
  {
    value: ENUM_PUSH_STATUS.COMPLETED,
    label: "Completed",
  },
];

export const ENUM_BAR_LIST_PLAN = {
  LIST_PLAN: "List",
  BOOST_PLAN: "Boost",
};

export const COLOR_BAR_LIST_PLAN: any = {
  [ENUM_BAR_LIST_PLAN.LIST_PLAN]: "primary",
  [ENUM_BAR_LIST_PLAN.BOOST_PLAN]: "warning",
};

export const LIST_OPTION_BAR_LIST_PLAN = [
  {
    value: ENUM_BAR_LIST_PLAN.LIST_PLAN,
    label: "Plan_List",
  },
  {
    value: ENUM_BAR_LIST_PLAN.BOOST_PLAN,
    label: "Plan_Boost",
  },
];

export const ENUM_BAR_LIST_OPEN_STATUS = {
  OPEN: 1,
  CLOSED: 0,
};

export const COLOR_BAR_LIST_OPEN_STATUS: any = {
  [ENUM_BAR_LIST_OPEN_STATUS.OPEN]: "success",
  [ENUM_BAR_LIST_OPEN_STATUS.CLOSED]: "danger",
};

export const LIST_OPTION_BAR_LIST_OPEN_STATUS = [
  {
    label: "Open",
    value: ENUM_BAR_LIST_OPEN_STATUS.OPEN,
  },
  {
    label: "Closed",
    value: ENUM_BAR_LIST_OPEN_STATUS.CLOSED,
  },
];

export const COLOR_BAR_LIST_PARTNER_STATUS: any = {
  ["partnered"]: "success",
  ["general"]: "danger",
};

export const LIST_OPTION_BAR_LIST_PARTNER_STATUS = [
  {
    label: "Partner",
    value: "partnered",
  },
  {
    label: "General",
    value: "general",
  },
];

export const LIST_OPTION_BAR_LIST_TYPE = [
  {
    label: "Lounge",
    value: "Lounge",
  },
  {
    label: "Theme Bar",
    value: "Theme Bar",
  },
  {
    label: "Traditional",
    value: "Traditional",
  },
  {
    label: "Skybar",
    value: "Skybar",
  },
];

export const LIST_OPTION_BAR_LIST_RATING = [1, 2, 3, 4, 5]?.map(
  (item: any) => ({
    value: item,
    label: item,
  })
);

export const ENUM_BAR_DETAIL_REVIEW_STATUS = {
  ACTIVE: 1,
  DISABLE: 0,
};

export const COLOR_BAR_DETAIL_REVIEW_STATUS: any = {
  [ENUM_BAR_DETAIL_REVIEW_STATUS.ACTIVE]: "primary",
  [ENUM_BAR_DETAIL_REVIEW_STATUS.DISABLE]: "warning",
};

export const COLOR_STICKER_STATUS: any = {
  [ENUM_BAR_DETAIL_REVIEW_STATUS.ACTIVE]: "success",
  [ENUM_BAR_DETAIL_REVIEW_STATUS.DISABLE]: "danger",
};

export const LIST_OPTION_BAR_DETAIL_REVIEW_STATUS = [
  {
    value: ENUM_BAR_DETAIL_REVIEW_STATUS.ACTIVE,
    label: "Active",
  },
  {
    value: ENUM_BAR_DETAIL_REVIEW_STATUS.DISABLE,
    label: "Disable",
  },
];

export const ENUM_STATUS_POST = {
  ACTIVATED: 1,
  DISABLED: 0,
};

export const ENUM_STATUS_APPLICATION = {
  PENDING: 0,
  IN_REVIEW: 1,
  RESULTED: 2,
};

export const COLOR_STATUS_POST: any = {
  [ENUM_STATUS_POST.ACTIVATED]: "success",
  [ENUM_STATUS_POST.DISABLED]: "danger",
};

export const ENUM_APPLICATION_STATUS = {
  VISIBLE: 1,
  INVISIBLE: 0,
};

export const COLOR_APPLICATION_STATUS: any = {
  [ENUM_APPLICATION_STATUS.VISIBLE]: "primary",
  [ENUM_APPLICATION_STATUS.INVISIBLE]: "warning",
};

export const LIST_OPTION_APPLICATION_STATUS = [
  {
    label: "Visible",
    value: ENUM_APPLICATION_STATUS.VISIBLE,
  },
  {
    label: "Invisible",
    value: ENUM_APPLICATION_STATUS.INVISIBLE,
  },
];

export const COLOR_STATUS_APPLICATION: any = {
  [ENUM_STATUS_APPLICATION.PENDING]: "warning",
  [ENUM_STATUS_APPLICATION.IN_REVIEW]: "primary",
  [ENUM_STATUS_APPLICATION.RESULTED]: "success",
};

export const STATUS_POST_OPTION = [
  {
    label: "Activated",
    value: ENUM_STATUS_POST.ACTIVATED,
  },
  {
    label: "Disabled",
    value: ENUM_STATUS_POST.DISABLED,
  },
];

export const ENUM_STICKER_PACKAGE_TYPE = {
  STANDARD: 0,
  PREMIUM: 1,
};

export const COLOR_STICKER_PACKAGE_TYPE: any = {
  [ENUM_STICKER_PACKAGE_TYPE.STANDARD]: "success",
  [ENUM_STICKER_PACKAGE_TYPE.PREMIUM]: "danger",
};

export const STICKER_PACKAGE_TYPE_OPTION = [
  {
    label: "Package Type Standard",
    value: ENUM_STICKER_PACKAGE_TYPE.STANDARD,
  },
  {
    label: "Package Type Premium",
    value: ENUM_STICKER_PACKAGE_TYPE.PREMIUM,
  },
];

export const LIST_CHANNEL_OPTION = [
  {
    label: "Facebook",
    value: "facebook",
  },
  {
    label: "Google",
    value: "google",
  },
  {
    label: "Tiktok",
    value: "tiktok",
  },
  {
    label: "Offline",
    value: "offline",
  },
];

export const AGENCY_APP_NAME_OPTION = [
  {
    label: "User",
    value: "baive",
  },
  {
    label: "Management",
    value: "baive_manager",
  },
];

export const ENUM_AGENCY_EVENT_ACTION_TYPE = {
  INSTALL: "install",
  OPEN: "open",
};

export const COLOR_AGENCY_EVENT_ACTION_TYPE: any = {
  [ENUM_AGENCY_EVENT_ACTION_TYPE.INSTALL]: "primary",
  [ENUM_AGENCY_EVENT_ACTION_TYPE.OPEN]: "success",
};

export const AGENCY_EVENT_ACTION_TYPE_OPTION = [
  {
    label: "Install",
    value: ENUM_AGENCY_EVENT_ACTION_TYPE.INSTALL,
  },
  {
    label: "Open",
    value: ENUM_AGENCY_EVENT_ACTION_TYPE.OPEN,
  },
];

export const PERIOD_DATE_OPTION = [
  {
    label: "No Specific Dates",
    value: "2",
  },
  {
    label: "Custom Period",
    value: "1",
  },
];

export const MANUAL_PUSH_REDIRECT_SCREEN_TARGET = [
  {
    label: "Open App",
    value: "default",
  },
  {
    label: "Open Deep Link",
    value: "open_link",
  },
  {
    label: "Job Post",
    value: "job_post",
  },
  {
    label: "Job Post Payment Complete",
    value: "job_post_payment_complete",
  },
  {
    label: "Job Application",
    value: "job_application",
  },
  {
    label: "Talent List",
    value: "talent_list",
  },
  {
    label: "Manage Recruitment",
    value: "manage_recruitment",
  },
  {
    label: "Community",
    value: "community",
  },
  {
    label: "Profile",
    value: "profile",
  },
  {
    label: "Promotion/ Event",
    value: "event",
  },
  {
    label: "Review",
    value: "review",
  },
  {
    label: "Comment",
    value: "comment",
  },
  {
    label: "Like",
    value: "like",
  },
  {
    label: "Like Comment",
    value: "like_comment",
  },  
];

export const ENUM_MANUAL_PUSH_SEND_TIME = {
  IMMEDIATELY: "immediately",
  SCHEDULE: "schedule",
};

export const COLOR_MANUAL_PUSH_SEND_TIME: any = {
  [ENUM_MANUAL_PUSH_SEND_TIME.IMMEDIATELY]: "primary",
  [ENUM_MANUAL_PUSH_SEND_TIME.SCHEDULE]: "warning",
};

export const MANUAL_PUSH_SEND_TIME_OPTION = [
  {
    value: ENUM_MANUAL_PUSH_SEND_TIME.IMMEDIATELY,
    label: "Immediately",
  },
  {
    value: ENUM_MANUAL_PUSH_SEND_TIME.SCHEDULE,
    label: "Schedule",
  },
];

export const ENUM_PUSH_LOG_OPEN_STATUS = {
  OPEN: 1,
  NOTOPEN: 0,
};

export const COLOR_OPEN_STATUS: any = {
  [ENUM_PUSH_LOG_OPEN_STATUS.OPEN]: "primary",
  [ENUM_PUSH_LOG_OPEN_STATUS.NOTOPEN]: "danger",
};

export const PUSH_LOG_OPEN_STATUS = [
  {
    value: ENUM_PUSH_LOG_OPEN_STATUS.OPEN,
    label: "Log Open",
  },
  {
    value: ENUM_PUSH_LOG_OPEN_STATUS.NOTOPEN,
    label: "Log Not-Open",
  },
];

export const PUSH_LOG_NOTIFY_TYPE = [
  {
    value: ENUM_NOTIFY_TYPE.AUTO,
    label: "Auto",
  },
  {
    value: ENUM_NOTIFY_TYPE.MANUAL,
    label: "Manual",
  },
];

export const ENUM_PUSH_LOG_PUSH_STATUS = {
  SENT: "sent",
  FAILED: "failed",
  DEACTIVATED: "deactivated",
  SENDING: "initialized",
};

export const COLOR_PUSH_LOG_STATUS = {
  [ENUM_PUSH_LOG_PUSH_STATUS.SENT]: "success",
  [ENUM_PUSH_LOG_PUSH_STATUS.FAILED]: "danger",
  [ENUM_PUSH_LOG_PUSH_STATUS.SENDING]: "warning",
  [ENUM_PUSH_LOG_PUSH_STATUS.DEACTIVATED]: "purple",
};

export const PUSH_LOG_PUSH_STATUS = [
  {
    value: ENUM_PUSH_LOG_PUSH_STATUS.SENT,
    label: "Sent",
  },
  {
    value: ENUM_PUSH_LOG_PUSH_STATUS.FAILED,
    label: "Failed",
  },
  {
    value: ENUM_PUSH_LOG_PUSH_STATUS.SENDING,
    label: "Sending",
  },
];

export const ENUM_MANUAL_PUSH_STATUS = {
  COMPLETED: "completed",
  INPROGRESS: "processing",
  WAITING: "waiting",
  CANCEL: "cancel",
};

export const COLOR_MANUAL_PUSH_STATUS = {
  [ENUM_MANUAL_PUSH_STATUS.COMPLETED]: "success",
  [ENUM_MANUAL_PUSH_STATUS.INPROGRESS]: "blue",
  [ENUM_MANUAL_PUSH_STATUS.WAITING]: "warning",
  [ENUM_MANUAL_PUSH_STATUS.CANCEL]: "danger",
};

export const MANUAL_PUSH_STATUS = [
  {
    value: ENUM_MANUAL_PUSH_STATUS.COMPLETED,
    label: "Complete",
  },
  {
    value: ENUM_MANUAL_PUSH_STATUS.INPROGRESS,
    label: "Processing",
  },
  {
    value: ENUM_MANUAL_PUSH_STATUS.WAITING,
    label: "Manual Push Waiting",
  },
  {
    value: ENUM_MANUAL_PUSH_STATUS.CANCEL,
    label: "Cancel",
  },
];

//Coupon issue
export const ENUM_COUPON_USE_STATUS = {
  USED: "1",
  NOT_USED: "2",
  EXPIRED: "3",
};

export const COLOR_COUPON_USE_STATUS: any = {
  [ENUM_COUPON_USE_STATUS.USED]: "success",
  [ENUM_COUPON_USE_STATUS.NOT_USED]: "warning",
  [ENUM_COUPON_USE_STATUS.EXPIRED]: "danger",
};

export const COUPON_USE_STATUS_OPTION = [
  { label: "Used", value: ENUM_COUPON_USE_STATUS.USED },
  { label: "Not-Used", value: ENUM_COUPON_USE_STATUS.NOT_USED },
  { label: "Expired", value: ENUM_COUPON_USE_STATUS.EXPIRED },
];

// Coupon Action Log

//Coupon
export const ENUM_COUPON_LOG_STATUS = {
  SUCCESS: 1,
  ERROR: 2,
};

export const COLOR_COUPON_LOG_STATUS: any = {
  [ENUM_COUPON_LOG_STATUS.SUCCESS]: "success",
  [ENUM_COUPON_LOG_STATUS.ERROR]: "danger",
};

export const COUPON_ACTION_LOG_STATUS = [
  { label: "Success", value: ENUM_COUPON_LOG_STATUS.SUCCESS },
  { label: "Error", value: ENUM_COUPON_LOG_STATUS.ERROR },
];

// User is guest
export const ENUM_USER_REAL_GUEST = {
  GUEST: "1",
  USER: "0",
};

export const ENUM_GUEST_MODE = {
  GUEST: "1",
  USER: "0",
};

export const COLOR_USER_REAL_GUEST: any = {
  [ENUM_USER_REAL_GUEST.GUEST]: "orange",
  [ENUM_USER_REAL_GUEST.USER]: "success",
};

export const USER_REAL_GUEST_OPTION = [
  { label: "Normal User", value: ENUM_USER_REAL_GUEST.USER },
  { label: "Guest", value: ENUM_USER_REAL_GUEST.GUEST },
];

export const GUEST_MODE_OPTION = [
  { label: "Normal", value: ENUM_GUEST_MODE.USER },
  { label: "Guest", value: ENUM_GUEST_MODE.GUEST },
];

export const LIST_USER_LOG_TYPE_OPTION = [
  { label: "Periodically Updated", value: 1 },
  /* { label: "Sign Up", value: 2 }, */
  { label: "Sign In", value: 3 },
  { label: "Bar List", value: 4 },
  { label: "Wink List", value: 5 },
];

export const COLOR_USER_LOG_TYPE: any = {
  [1]: "orange",
  [2]: "success",
  [3]: "danger",
  [4]: "primary",
  [5]: "purple",
};

export const LIST_OPTION_SOURCE_APP = [
  {
    label: "App User",
    value: "baive",
  },
  {
    label: "App Management",
    value: "baive_manager",
  },
];

export const LIST_OPTION_MENU = [
  {
    label: "Bar",
    value: "1",
  },
  {
    label: "Bar Manager",
    value: "2",
  },
  {
    label: "Feed",
    value: "3",
  },
  {
    label: "Wink",
    value: "4",
  },
  {
    label: "News",
    value: "5",
  },
  {
    label: "Profile",
    value: "6",
  },
];

export const APP_TYPE_OPTIONS: Option[] = [
  {
    label: "Type User",
    value: "user",
  },
  {
    label: "Type Management",
    value: "manager",
  },
];

// User Type on Log page
export const ENUM_USER_TYPE_LOG = {
  GUEST: "GUEST",
  APPLICANT: "APPLICANT",
  MANAGER: "MANAGER",
};

export const COLOR_USER_TYPE_LOG: any = {
  [ENUM_USER_TYPE_LOG.GUEST]: "warning",
  [ENUM_USER_TYPE_LOG.APPLICANT]: "success",
  [ENUM_USER_TYPE_LOG.MANAGER]: "danger",
};

export const USER_TYPE_LOG_OPTION = [
  { label: "Guest", value: ENUM_USER_TYPE_LOG.GUEST },
  { label: "Job Seeker", value: ENUM_USER_TYPE_LOG.APPLICANT },
  { label: "Recruiter", value: ENUM_USER_TYPE_LOG.MANAGER },
];

export const USER_TYPE_NOTICE_OPTION = [
  { label: "Job Seeker", value: ENUM_USER_TYPE_LOG.APPLICANT },
  { label: "Recruiter", value: ENUM_USER_TYPE_LOG.MANAGER },
];

export const ENUM_LOGIN_TYPE_LOG = {
  GUEST: "GUEST",
  EMAIL: "EMAIL",
  SOCIAL: "SOCIAL",
};

export const COLOR_LOGIN_TYPE_LOG: any = {
  [ENUM_LOGIN_TYPE_LOG.GUEST]: "warning",
  [ENUM_LOGIN_TYPE_LOG.EMAIL]: "success",
  [ENUM_LOGIN_TYPE_LOG.SOCIAL]: "primary",
};

export const USER_LOGIN_TYPE_OPTION = [
  { label: "Guest", value: ENUM_LOGIN_TYPE_LOG.GUEST },
  { label: "Email", value: ENUM_LOGIN_TYPE_LOG.EMAIL },
  { label: "Social", value: ENUM_LOGIN_TYPE_LOG.SOCIAL },
];

export const LIST_CHANNEL_USER_OPTION = [
  {
    label: "Channel Store",
    value: "store",
  },
  {
    label: "Channel Agency",
    value: "agency",
  },
  {
    label: "Channel Google",
    value: "google",
  },
  {
    label: "Channel Meta",
    value: "meta",
  },
];

// event log
export const JOB_POST_SCREEN_CONST = [
  {
    value: "access_screen",
    label: "Access Screen (Job Post)",
  },
  {
    value: "filter_job_posts",
    label: "Filter Job Post (Job Post)",
  },
  {
    value: "select_regions",
    label: "Select Regions (Job Post)",
  },
  {
    value: "click_banner",
    label: "Click Banner (Job Post)",
  },
  {
    value: "click_job_post",
    label: "Click Job Post (Job Post)",
  },
  {
    value: "click_view_benefits",
    label: "Click View Benefits (Job Post)",
  },
  {
    value: "swipe_section",
    label: "Swipe Section (Job Post)",
  },
  {
    value: "load_more_job_post",
    label: "Load More Job Post (Job Post)",
  },
  {
    value: "close_toast",
    label: "Close Toast (Job Post)",
  },
  {
    value: "click_policy",
    label: "Click Policy (Job Post)",
  },
];
export const FIND_TALENT_SCREEN_CONST = [
  {
    value: "access_screen",
    label: "Access Screen (Find Talent)",
  },
  {
    value: "filter_talents",
    label: "Filter Talent (Find Talent)",
  },
  {
    value: "click_view_talent",
    label: "Click View Talent (Find Talent)",
  },
  {
    value: "click_call",
    label: "Click Call (Find Talent)",
  },
  {
    value: "view_image",
    label: "View Image (Find Talent)",
  },
];

export const MANAGER_RECRUITMENT_SCREEN_CONST = [
  {
    value: "access_screen",
    label: "Access Screen (Manager Recruitment)",
  },
  {
    value: "click_recruitment_card",
    label: "Click Recruitment Card (Manager Recruitment)",
  },
  {
    value: "click_job_post",
    label: "Click Job Post (Manager Recruitment)",
  },
  {
    value: "click_repost_job_post",
    label: "Click Repost Job Post (Manager Recruitment)",
  },
  {
    value: "click_jump_job_post",
    label: "Click Jump Job Post (Manager Recruitment)",
  },
  {
    value: "click_edit",
    label: "Click Edit (Manager Recruitment)",
  },
  {
    value: "click_view_applicants",
    label: "Click View Applicants (Manager Recruitment)",
  },
  {
    value: "click_payment_amount",
    label: "Click Payment Amount (Manager Recruitment)",
  },
  {
    value: "click_create_job_post",
    label: "Click Create Job Post (Manager Recruitment)",
  },
  {
    value: "click_notification",
    label: "Click Notification (Manager Recruitment)",
  },
  {
    value: "click_tab_active_job_post",
    label: "Click Tab Active Job Post (Manager Recruitment)",
  },
  {
    value: "click_tab_closed_job_post",
    label: "Click Tab Closed Job Post (Manager Recruitment)",
  },
  {
    value: "jump_job_post_failed",
    label: "Jump Job Post Failed (Manager Recruitment)",
  },
  {
    value: "jump_job_post_success",
    label: "Jump Job Post Success (Manager Recruitment)",
  },
  {
    value: "repost_job_post_success",
    label: "Repost Job Post Success (Manager Recruitment)",
  },
];

export const JOB_POST_DETAIL_SCREEN_CONST = [
  {
    value: "access_screen",
    label: "Access Screen (Job Post Detail)",
  },
  {
    value: "apply_job_post",
    label: "Apply Job Post (Job Post Detail)",
  },
  {
    value: "click_call",
    label: "Click Call (Job Post Detail)",
  },
  {
    value: "click_send_message",
    label: "Click Send Message (Job Post Detail)",
  },
  {
    value: "share",
    label: "Share (Job Post Detail)",
  },
  {
    value: "view_image",
    label: "View Image (Job Post Detail)",
  },
  {
    value: "click_map",
    label: "Click Map (Job Post Detail)",
  },
  {
    value: "click_join_kakao_channel",
    label: "Click Join Kakao Channel (Job Post Detail)",
  },
];

export const PAYMENT_AMOUNT_SCREEN_CONST = [
  { value: "access_screen", label: "Access Screen (Payment Amount)" },
  { value: "cancel_payment", label: "Cancel Payment (Payment Amount)" },
  { value: "payment_again", label: "Payment Again (Payment Amount)" },
  { value: "click_contact_kakao_customer_center", label: "Click Contact Kakao Customer Center (Payment Amount)" },
  { value: "click_confirm_button", label: "Click Confirm Button (Payment Amount)" },
];

export const COMMUNITY_DETAIL_SCREEN_CONST = [
  { value: "click_like_post", label: "Click Like Post (Community Detail)" },
  { value: "comment_post", label: "Comment Post (Community Detail)" },
  { value: "report_post", label: "Report Post (Community Detail)" },
  { value: "block_user", label: "Block User (Community Detail)" },
  { value: "report_comment", label: "Report Comment (Community Detail)" },
  { value: "block_comment", label: "Block Comment (Community Detail)" },
  { value: "like_comment", label: "Like Comment (Community Detail)" },
  { value: "reply_comment", label: "Reply Comment (Community Detail)" },
  { value: "view_media", label: "View Media (Community Detail)" },
];

export const COMMUNITY_SCREEN_CONST = [
  { value: "access_screen", label: "Access Screen (Community)" },
  { value: "filter_by_category", label: "Filter By Category (Community)" },
  { value: "click_notification", label: "Click Notification (Community)" },
  { value: "click_search_icon", label: "Click Search Icon (Community)" },
  { value: "click_login", label: "Click Login (Community)" },
  { value: "create_post", label: "Create Post (Community)" },
  { value: "click_banner_ads", label: "Click Banner Ads (Community)" },
  { value: "click_view_post", label: "Click View Post (Community)" },
  { value: "click_like", label: "Click Like (Community)" },
  { value: "click_comment", label: "Click Comment (Community)" },
];

export const PROFILE_RECRUITMENT_SCREEN_CONST = [
  { value: "access_screen", label: "Access Screen (Profile Recruitment)" },
  { value: "edit_profile", label: "Edit Profile (Profile Recruitment)" },
  { value: "click_setting", label: "Click Setting (Profile Recruitment)" },
  { value: "update_store_profile", label: "Update Store Profile (Profile Recruitment)" },
  { value: "update_business_info", label: "Update Bussiness Info (Profile Recruitment)" },
  { value: "switch_role", label: "Swith Role (Profile Recruitment)" },
  { value: "click_contact_kakao_customer_center", label: "Click Contact Kakao Customer Center (Profile Recruitment)" },
];

export const ADULT_VERIFICATION_SCREEN_CONST = [
  { value: "request_adult_verification", label: "Request Adult Verification (Adult Verification)" },
  { value: "adult_verification_success", label: "Adult Verification Success (Adult Verification)" },
  { value: "adult_verification_failure", label: "Adult Verification Failure (Adult Verification)" },
];

export const FAQ_SCREEN_CONST = [
  { value: "access_screen", label: "Access Screen (FAQ)" },
  { value: "view_detail", label: "View Detail (FAQ)" },
];

export const NOTIFICATION_SETTING_SCREEN_CONST = [
  { value: "access_screen", label: "Access Screen (Notification Setting)" },
  { value: "click_toggle ", label: "Click Toggle (Notification Setting)" },
];

export const PROFILE_JOB_SEEKER_SCREEN_CONST = [
  { value: "access_screen", label: "Access Screen (Profile Job Seeker)" },
  { value: "click_view", label: "Click View (Profile Job Seeker)" },
  { value: "edit_profile", label: "Edit Profile (Profile Job Seeker)" },
  { value: "click_setting", label: "Click Setting (Profile Job Seeker)" },
  { value: "update_user_profile", label: "Update User Profile (Profile Job Seeker)" },
  { value: "view_work_experience", label: "View Work Experience (Profile Job Seeker)" },
  { value: "allow_resume_view", label: "Allow Resume View (Profile Job Seeker)" },
  { value: "see_more_experience", label: "See More Experience (Profile Job Seeker)" },
  { value: "add_experience", label: "Add Experience (Profile Job Seeker)" },
  { value: "delete_experience", label: "Delete Experience (Profile Job Seeker)" },
  { value: "switch_role", label: "Switch Role (Profile Job Seeker)" },
  { value: "click_contact_kakao_customer_center", label: "Click Contact Kakao Customer Center (Profile Job Seeker)" },
  { value: "search_job", label: "Search Job (Profile Job Seeker)" },
  { value: "click_view_application_job", label: "Click View Application Job (Profile Job Seeker)" },
  { value: "click_go_to_job_post", label: "Click Go To Job Post (Profile Job Seeker)" },
  { value: "click_go_to_community", label: "Click Go To Community (Profile Job Seeker)" },
  { value: "search_store", label: "Search Store (Profile Job Seeker)" },
];

export const INQUIRY_SCREEN_CONST = [
  { value: "access_screen", label: "Access Screen (Inquiry)" },
  { value: "view_detail", label: "View Detail (Inquiry)" },
  { value: "create_inquiry", label: "Create Inquiry (Inquiry)" },
  { value: "reply_inquiry", label: "Reply Inquiry (Inquiry)" },
];

export const SETTING_SCREEN_CONST = [
  { value: "access_screen", label: "Access Screen (Setting)" },
  { value: "click_info", label: "Click Info (Setting)" },
  { value: "click_faq ", label: "Click FAQ (Setting)" },
  { value: "click_notification_setting", label: "Click Notification Setting (Setting)" },
  { value: "click_inquiry", label: "Click Inquiry (Setting)" },
  { value: "click_logout", label: "Click Logout (Setting)" },
  { value: "click_withdraw ", label: "Click Withdraw (Setting)" },
];

export const LOGIN_SCREEN_CONST = [
  { value: "access_screen", label: "Access Screen (Login)" },
];

export const APP_INFO_SCREEN_CONST = [
  { value: "access_screen", label: "Access Screen (App Info)" },
];

export const SCREEN_CONST = [
  {
    value: "home",
    label: "Home (Job Post)",
    children: JOB_POST_SCREEN_CONST,
  },
  {
    value: "job_post_detail",
    label: "Job Post Detail",
    children: JOB_POST_DETAIL_SCREEN_CONST,
  },
  {
    value: "find_talent",
    label: "Find Talent",
    children: FIND_TALENT_SCREEN_CONST,
  },
  {
    value: "recruitment_management",
    label: "Manager Recruitment",
    children: MANAGER_RECRUITMENT_SCREEN_CONST,
  },
  {
    value: "payment_management",
    label: "Payment Amount",
    children: PAYMENT_AMOUNT_SCREEN_CONST,
  },
  {
    value: "community",
    label: "Community Screen",
    children: COMMUNITY_SCREEN_CONST,
  },
  {
    value: "community_detail",
    label: "Community Detail",
    children: COMMUNITY_DETAIL_SCREEN_CONST,
  },
  {
    value: "recruiter_profile",
    label: "Profile Recruitment",
    children: PROFILE_RECRUITMENT_SCREEN_CONST,
  },
  {
    value: "job_seeker_profile",
    label: "Profile Job Seeker",
    children: PROFILE_JOB_SEEKER_SCREEN_CONST,
  },
  {
    value: "adult_verification",
    label: "Adult Verification",
    children: ADULT_VERIFICATION_SCREEN_CONST,
  },
  // {
  //   value: "login_screen",
  //   label: "Login",
  //   children: LOGIN_SCREEN_CONST,
  // },
  {
    value: "setting",
    label: "Setting",
    children: SETTING_SCREEN_CONST,
  },
  {
    value: "app_info",
    label: "App Info",
    children: APP_INFO_SCREEN_CONST,
  },
  {
    value: "faq",
    label: "FAQ",
    children: FAQ_SCREEN_CONST,
  },
  {
    value: "notification_setting",
    label: "Notification Setting",
    children: NOTIFICATION_SETTING_SCREEN_CONST,
  },
  {
    value: "inquiry",
    label: "Inquiry",
    children: INQUIRY_SCREEN_CONST,
  },
];

//end of event log

//start of notification
export const NOTIFICATION_ACTION = [
  { value: "default", label: "Open App" },
  { value: "connect", label: "Connect" },
  { value: "comment", label: "Comment" },
  { value: "message", label: "Message" },
  { value: "home", label: "Home" },
  { value: "search", label: "Search" },
  { value: "explore", label: "Explore" },
  { value: "like", label: "Like" },
  { value: "dislike", label: "Dislike" },
  { value: "bookmark", label: "Bookmark" },
  { value: "unbookmark", label: "Unbookmark" },
  { value: "message-private-chat", label: "Message Private Chat" },
  { value: "message-group-chat", label: "Message Group Chat" },
  { value: "open-link", label: "Open Link" },
  { value: "bar", label: "Notify Bar" },
  { value: "bar-management", label: "Notify Bar Management" },
  { value: "wink", label: "Wink" },
  { value: "news", label: "News" },
  { value: "chat", label: "Chat" },
  { value: "profile", label: "Profile" },
  { value: "share", label: "Shared" },
];

export const ENUM_USER_TYPE_BAR = {
  NORMAL_USER: 1,
  BARTENDER: 2,
  MANAGER: 3,
};

export const COLOR_USER_TYPE_BAR: any = {
  [ENUM_USER_TYPE_BAR.NORMAL_USER]: "success",
  [ENUM_USER_TYPE_BAR.BARTENDER]: "danger",
  [ENUM_USER_TYPE_BAR.MANAGER]: "info",
};

export const USER_TYPE_BAR_OPTION = [
  { label: "Normal User", value: ENUM_USER_TYPE_BAR.NORMAL_USER },
  { label: "Bartender", value: ENUM_USER_TYPE_BAR.BARTENDER },
  { label: "Label Manager", value: ENUM_USER_TYPE_BAR.MANAGER },
];

//hashtag
export const ENUM_HASHTAG_STATUS = {
  ACTIVATED: 1,
  INACTIVATED: 0,
};

export const COLOR_HASHTAG_STATUS: any = {
  [ENUM_HASHTAG_STATUS.ACTIVATED]: "success",
  [ENUM_HASHTAG_STATUS.INACTIVATED]: "danger",
};

export const HASHTAG_STATUS_OPTION = [
  { label: "Active", value: ENUM_HASHTAG_STATUS.ACTIVATED },
  { label: "InActive", value: ENUM_HASHTAG_STATUS.INACTIVATED },
];

export const AGENCY_CUSTOM_PARAM_CHANNEL_OPTION = [
  {
    label: "Google Ads Tracking",
    value: "google",
  },
  {
    label: "Meta Ads tracking",
    value: "meta",
  },
];

//Send push
export const ENUM_MANUAL_PUSH_SAVE_OPTION = {
  SAVE: 1,
  NOT_SAVE: 0,
};

export const COLOR_MANUAL_PUSH_SAVE_OPTION: any = {
  [ENUM_MANUAL_PUSH_SAVE_OPTION.SAVE]: "primary",
  [ENUM_MANUAL_PUSH_SAVE_OPTION.NOT_SAVE]: "warning",
};

export const MANUAL_PUSH_SAVE_OPTION = [
  {
    value: ENUM_MANUAL_PUSH_SAVE_OPTION.SAVE,
    label: "Save",
  },
  {
    value: ENUM_MANUAL_PUSH_SAVE_OPTION.NOT_SAVE,
    label: "Not-save",
  },
];

export const STATUS_APPLICATION_OPTION = [
  {
    label: "Pending",
    value: ENUM_STATUS_APPLICATION.PENDING,
  },
  {
    label: "InReview",
    value: ENUM_STATUS_APPLICATION.IN_REVIEW,
  },
  {
    label: "Resulted",
    value: ENUM_STATUS_APPLICATION.RESULTED,
  },
];

//onny job
export const RESERVATION_USER_TYPE = [
  {
    label: "Job Seeker",
    value: "APPLICANT",
  },
  {
    label: "Recruiter",
    value: "MANAGER",
  },
];

export const COLOR_RESERVATION_USER_TYPE: any = {
  ["APPLICANT"]: "success",
  ["MANAGER"]: "danger",
};

export const RESERVATION_EXPERIENCE_LEVEL = [
  {
    label: "Newbie",
    value: "신입",
  },
  {
    label: "Less than 1 year",
    value: "1년 미만",
  },
  {
    label: "1-3 years",
    value: "1~3년",
  },
  {
    label: "3-5 years",
    value: "3~5년",
  },
  {
    label: "More than 5 years",
    value: "5년 이상",
  },
];

export const ENUM_USER_TYPE = {
  GUEST: "GUEST",
  NORMAL_USER: "NORMAL",
};

export const COLOR_USER_TYPE: any = {
  [ENUM_USER_TYPE.GUEST]: "orange",
  [ENUM_USER_TYPE.NORMAL_USER]: "info",
};

export const LIST_OPTION_USER_TYPE = [
  { label: "Guest", value: ENUM_USER_TYPE.GUEST },
  { label: "Normal User", value: ENUM_USER_TYPE.NORMAL_USER },
];

export const ENUM_ADULT_VERIFY = {
  VERIFIED: 1,
  NOT_VERIFIED: 0,
};

export const COLOR_ADULT_VERIFY: any = {
  [ENUM_ADULT_VERIFY.VERIFIED]: "primary",
  [ENUM_ADULT_VERIFY.NOT_VERIFIED]: "orange",
};

export const LIST_OPTION_ADULT_VERIFY = [
  { label: "Verified", value: ENUM_ADULT_VERIFY.VERIFIED },
  { label: "Not-Verified", value: ENUM_ADULT_VERIFY.NOT_VERIFIED },
];

export const ENUM_STORE_CONNECTION = {
  LINKED: 1,
  NOT_LINKED: 0,
};

export const COLOR_STORE_CONNECTION: any = {
  [ENUM_STORE_CONNECTION.LINKED]: "primary",
  [ENUM_STORE_CONNECTION.NOT_LINKED]: "warning",
};

export const LIST_OPTION_STORE_CONNECTION = [
  { label: "Store Linked", value: ENUM_STORE_CONNECTION.LINKED },
  { label: "Store Not Linked", value: ENUM_STORE_CONNECTION.NOT_LINKED },
];

export const ENUM_JOB_POSTING_STATUS = {
  POSTED: 1,
  NOT_POSTED: 0,
};

export const COLOR_JOB_POSTING_STATUS: any = {
  [ENUM_JOB_POSTING_STATUS.POSTED]: "info",
  [ENUM_JOB_POSTING_STATUS.NOT_POSTED]: "orange",
};

export const LIST_OPTION_JOB_POSTING_STATUS = [
  { label: "Posted", value: ENUM_JOB_POSTING_STATUS.POSTED },
  { label: "Not Posted", value: ENUM_JOB_POSTING_STATUS.NOT_POSTED },
];

export const ENUM_STATUS_JOB_POST = {
  DRAFT: "DRAFT",
  PAYMENT_PENDING: "PAYMENT_PENDING",
  ACTIVE: "ACTIVE",
  SCHEDULE: "SCHEDULE",
  EXPIRED: "EXPIRED",
  CLOSED: "CLOSED",
  REJECTED: "REJECTED",
  CANCEL: "PAYMENT_CANCEL",
  PAUSED: "PAUSED",
};

export const COLOR_STATUS_JOB_POST: any = {
  [ENUM_STATUS_JOB_POST.DRAFT]: "orange-medium",
  [ENUM_STATUS_JOB_POST.PAYMENT_PENDING]: "blue-medium",
  [ENUM_STATUS_JOB_POST.ACTIVE]: "green-medium",
  [ENUM_STATUS_JOB_POST.SCHEDULE]: "purple-medium",
  [ENUM_STATUS_JOB_POST.EXPIRED]: "gray-light",
  [ENUM_STATUS_JOB_POST.CLOSED]: "gray-medium",
  [ENUM_STATUS_JOB_POST.REJECTED]: "red-medium",
  [ENUM_STATUS_JOB_POST.CANCEL]: "red-light",
  [ENUM_STATUS_JOB_POST.PAUSED]: "orange-light",
};

export const LIST_OPTION_STATUS_JOB_POST = [
  { label: "Draft", value: ENUM_STATUS_JOB_POST.DRAFT },
  { label: "Payment Pending", value: ENUM_STATUS_JOB_POST.PAYMENT_PENDING },
  { label: "Payment Cancel", value: ENUM_STATUS_JOB_POST.CANCEL },
  { label: "Job Post Active", value: ENUM_STATUS_JOB_POST.ACTIVE },
  { label: "Job Post Schedule", value: ENUM_STATUS_JOB_POST.SCHEDULE },
  { label: "Job Post Pause", value: ENUM_STATUS_JOB_POST.PAUSED },
  { label: "Job Post Expired", value: ENUM_STATUS_JOB_POST.EXPIRED },
  { label: "Job Post Closed", value: ENUM_STATUS_JOB_POST.CLOSED },
  { label: "Job Post Rejected", value: ENUM_STATUS_JOB_POST.REJECTED },
];

export const LIST_OPTION_SALARY_TYPE = [
  { label: "Hourly", value: "HOURLY" },
  { label: "Daily", value: "DAILY" },
  { label: "Weekly", value: "WEEKLY" },
  { label: "Monthly", value: "MONTHLY" },
];

export const ENUM_EMPLOYMENT_TYPE = {
  PARTIME: "PART_TIME",
  FULLTIME: "FULL_TIME",
  CONTRACT: "CONTRACT",
};

export const COLOR_EMPLOYMENT_TYPE: any = {
  [ENUM_EMPLOYMENT_TYPE.PARTIME]: "warning",
  [ENUM_EMPLOYMENT_TYPE.FULLTIME]: "primary",
  [ENUM_EMPLOYMENT_TYPE.CONTRACT]: "success",
};

export const LIST_OPTION_EMPLOYMENT_TYPE = [
  { label: "Part Time", value: ENUM_EMPLOYMENT_TYPE.PARTIME },
  { label: "Full Time", value: ENUM_EMPLOYMENT_TYPE.FULLTIME },
  { label: "Contract", value: ENUM_EMPLOYMENT_TYPE.CONTRACT },
];

export const COLOR_DURATION_WORK: any = {
  ["ONE_WEEK"]: "info",
  ["ONE_MONTH"]: "primary",
  ["THREE_MONTHS"]: "warning",
  ["SIX_MONTHS"]: "orange",
  ["ONE_YEAR"]: "success",
};

export const LIST_OPTION_DURATION_WORK = [
  { label: "1 week", value: "ONE_WEEK" },
  { label: "1 month", value: "ONE_MONTH" },
  { label: "3 months", value: "THREE_MONTHS" },
  { label: "6 months", value: "SIX_MONTHS" },
  { label: "1 year", value: "ONE_YEAR" },
  // { label: "Negotiation", value: "NEGOTIATION" },
];

export const ENUM_JOB_POST_STATUS = {
  ON_GOING: "ACTIVE",
  END: "EXPIRED",
  CANCELLED: "CANCEL",
};

export const COLOR_JOB_POST_STATUS: any = {
  [ENUM_JOB_POST_STATUS.ON_GOING]: "primary",
  [ENUM_JOB_POST_STATUS.END]: "secondary",
  [ENUM_JOB_POST_STATUS.CANCELLED]: "danger",
};

export const LIST_OPTION_JOB_POST_STATUS = [
  { label: "On-Going", value: ENUM_JOB_POST_STATUS.ON_GOING },
  { label: "End", value: ENUM_JOB_POST_STATUS.END },
  { label: "Cancelled", value: ENUM_JOB_POST_STATUS.CANCELLED },
];

export const ENUM_EXPERIENCE_USER = {
  EXPERIENCED: 1,
  NON_EXPERIENCED: 0,
};

export const COLOR_EXPERIENCE_USER: any = {
  [ENUM_EXPERIENCE_USER.EXPERIENCED]: "info",
  [ENUM_EXPERIENCE_USER.NON_EXPERIENCED]: "secondary",
};

export const LIST_OPTION_EXPERIENCE = [
  {
    label: "Non-Experienced",
    value: ENUM_EXPERIENCE_USER.NON_EXPERIENCED,
  },
  {
    label: "Experienced",
    value: ENUM_EXPERIENCE_USER.EXPERIENCED,
  },
];

export const ENUM_PRIORITY_JOB_POST = {
  HIGHEST: "HIGHEST",
  HIGHER: "HIGHER",
  NORMAL: "NORMAL",
};

export const COLOR_PRIORITY_JOB_POST: any = {
  [ENUM_PRIORITY_JOB_POST.HIGHEST]: "danger",
  [ENUM_PRIORITY_JOB_POST.HIGHER]: "orange",
  [ENUM_PRIORITY_JOB_POST.NORMAL]: "success",
};

export const LIST_OPTION_PRIORITY_JOB_POST = [
  { label: "Highest", value: ENUM_PRIORITY_JOB_POST.HIGHEST },
  { label: "Higher", value: ENUM_PRIORITY_JOB_POST.HIGHER },
  { label: "Normal", value: ENUM_PRIORITY_JOB_POST.NORMAL },
];

export const ENUM_EXPERIENCE_REQUIRED_JOB_POST = {
  REQUIRED: "REQUIRED",
  NOT_REQUIRED: "NOT_REQUIRED",
  NO_PREFERENCE: "NO_PREFERENCE",
};

export const COLOR_EXPERIENCE_REQUIRED_JOB_POST: any = {
  [ENUM_EXPERIENCE_REQUIRED_JOB_POST.REQUIRED]: "danger",
  [ENUM_EXPERIENCE_REQUIRED_JOB_POST.NOT_REQUIRED]: "warning",
  [ENUM_EXPERIENCE_REQUIRED_JOB_POST.NO_PREFERENCE]: "secondary",
};

export const LIST_OPTION_EXPERIENCE_REQUIRED_JOB_POST = [
  { label: "Experience", value: ENUM_EXPERIENCE_REQUIRED_JOB_POST.REQUIRED },
  {
    label: "Non-Experience",
    value: ENUM_EXPERIENCE_REQUIRED_JOB_POST.NOT_REQUIRED,
  },
  { label: "Any", value: ENUM_EXPERIENCE_REQUIRED_JOB_POST.NO_PREFERENCE },
];
export const ENUM_EXPERIENCE = {
  EXPERIENCED: "REQUIRED",
  NON_EXPERIENCED: "NO_REQUIRED",
};

export const COLOR_EXPERIENCE: any = {
  [ENUM_EXPERIENCE_USER.EXPERIENCED]: "success",
  [ENUM_EXPERIENCE_USER.NON_EXPERIENCED]: "orange",
};

export const OPTION_EXPERIENCE = [
  {
    label: "Experienced",
    value: ENUM_EXPERIENCE_USER.EXPERIENCED,
  },
  {
    label: "Non-Experienced",
    value: ENUM_EXPERIENCE_USER.NON_EXPERIENCED,
  },
];

export const ENUM_APPLICATION_STATUS2 = {
  SUBMITTED: "SUBMITTED",
  VIEWED: "VIEWED",
  INTERVIEW: "INTERVIEW",
  HIRED: "HIRED",
  REJECTED: "REJECTED",
  WITHDRAWN: "WITHDRAWN",
};

export const COLOR_APPLICATION_STATUS2: any = {
  [ENUM_APPLICATION_STATUS2.SUBMITTED]: "applied",
  [ENUM_APPLICATION_STATUS2.VIEWED]: "viewed",
  [ENUM_APPLICATION_STATUS2.INTERVIEW]: "interview",
  [ENUM_APPLICATION_STATUS2.HIRED]: "hired",
  [ENUM_APPLICATION_STATUS2.REJECTED]: "rejected",
  [ENUM_APPLICATION_STATUS2.WITHDRAWN]: "user-cancelled",
};

export const LIST_APPLICATION_STATUS = [
  {
    label: "Applied",
    value: ENUM_APPLICATION_STATUS2.SUBMITTED,
  },
  {
    label: "Viewed",
    value: ENUM_APPLICATION_STATUS2.VIEWED,
  },
  {
    label: "Interview",
    value: ENUM_APPLICATION_STATUS2.INTERVIEW,
  },
  {
    label: "Hired",
    value: ENUM_APPLICATION_STATUS2.HIRED,
  },
  {
    label: "Rejected",
    value: ENUM_APPLICATION_STATUS2.REJECTED,
  },
  {
    label: "User Cancelled",
    value: ENUM_APPLICATION_STATUS2.WITHDRAWN,
  },
];

export const LIST_OPERATOR_ROLE_OPTION = [
  {
    label: "Admin",
    value: "ADMIN",
  },
];

export const LIST_OPTION_SNS_TYPE = [
  {
    label: "Instagram",
    value: "INSTAGRAM",
  },
  {
    label: "YouTube",
    value: "YOUTUBE",
  },
  {
    label: "Facebook",
    value: "FACEBOOK",
  },
  {
    label: "Tiktok",
    value: "TIKTOK",
  },
  {
    label: "X",
    value: "X",
  },
  {
    label: "KAKAO",
    value: "KAKAO_TALK",
  },
  {
    label: "Telegram",
    value: "TELEGRAM",
  },
  {
    label: "Line",
    value: "LINE",
  },
  {
    label: "Other",
    value: "OTHER",
  },
];

export const LIST_OPTION_SALARY_TYPE_USER = [
  { label: "Hourly", value: "HOUR" },
  { label: "Daily", value: "DAILY" },
  { label: "Monthly", value: "MONTH" },
];
export const sortDays = (days: any) => {
  const dayOrder = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];
  return days.sort(
    (a: any, b: any) => dayOrder?.indexOf(a) - dayOrder?.indexOf(b)
  );
};
export const renderWorkingDays = (value: any) => {
  if (value) {
    const arr = Object.entries(value)
      ?.filter((i: any) => !!i?.[1])
      ?.map((i: any) => i?.[0]?.toLocaleLowerCase());

    return sortDays(arr)?.join(", ");
  } else {
    return "-";
  }
};

export const LIST_CURRENCY_OPTION = [
  {
    label: "KRW",
    value: "KRW",
  },
  {
    label: "USD",
    value: "USD",
  },
];

export const PLAN_TYPE_OPTION = [
  {
    label: "Job Posting",
    value: "JOB_POSTING",
  },
  {
    label: "Resume Viewing",
    value: "RESUME_VIEWING",
  },
  {
    label: "Type All",
    value: "ALL",
  },
];

export const PLAN_FEATURE_KEY_OPTION = [
  {
    label: "Post Job",
    value: "POST_JOB",
  },
  {
    label: "View Resume",
    value: "VIEW_RESUME",
  },
  {
    label: "Jump Rank",
    value: "JUMP_RANK",
  },
  // {
  //   label: "Boost Post",
  //   value: "BOOST_POST",
  // },
];

export const PLAN_FEATURE_LIMIT_TYPE = [
  {
    label: "Unlimited",
    value: "UNLIMITED",
  },
  {
    label: "Quota",
    value: "QUOTA",
  },
];

export const ENUM_USER_PLAN_STATUS = {
  ACTIVE: "ACTIVE",
  PENDING: "PENDING",
  CENCELLED: "CENCELLED",
  REVOKED: "REVOKED",
  INACTIVE: "INACTIVE",
};
export const COLOR_USER_PLAN_STATUS: any = {
  [ENUM_USER_PLAN_STATUS.ACTIVE]: "success",
  [ENUM_USER_PLAN_STATUS.PENDING]: "warning",
  [ENUM_USER_PLAN_STATUS.CENCELLED]: "secondary",
  [ENUM_USER_PLAN_STATUS.REVOKED]: "danger",
  [ENUM_USER_PLAN_STATUS.INACTIVE]: "info",
};

export const LIST_USER_PLAN_STATUS = [
  {
    label: "Active",
    value: ENUM_USER_PLAN_STATUS.ACTIVE,
  },
  {
    label: "Pending",
    value: ENUM_USER_PLAN_STATUS.PENDING,
  },
  {
    label: "Cancelled",
    value: ENUM_USER_PLAN_STATUS.CENCELLED,
  },
  {
    label: "Revoked",
    value: ENUM_USER_PLAN_STATUS.REVOKED,
  },
  {
    label: "Inactive",
    value: ENUM_USER_PLAN_STATUS.INACTIVE,
  },
];

export const ENUM_PLAN_PURCHASE_PAYMENT_METHOD = {
  TRANSFER: "TRANSFER",
  TRANSFER_VIRTUAL_ACCOUNT: "TRANSFER_VIRTUAL_ACCOUNT",
  GATEWAY: "GATEWAY",
  // for filter
  CREDIT_CARD: "CREDIT_CARD",
  FREE: "FREE"
};

export const COLOR_PLAN_PURCHASE_PAYMENT_METHOD: any = {
  [ENUM_PLAN_PURCHASE_PAYMENT_METHOD.TRANSFER]: "primary",
  [ENUM_PLAN_PURCHASE_PAYMENT_METHOD.TRANSFER_VIRTUAL_ACCOUNT]: "success",
  [ENUM_PLAN_PURCHASE_PAYMENT_METHOD.GATEWAY]: "orange",
  [ENUM_PLAN_PURCHASE_PAYMENT_METHOD.FREE]: "danger",
  // for filter
  [ENUM_PLAN_PURCHASE_PAYMENT_METHOD.CREDIT_CARD]: "orange",
};


export const LIST_PLAN_PURCHASE_PAYMENT_METHOD = [
  { 
    label: "Transfer", 
    value: ENUM_PLAN_PURCHASE_PAYMENT_METHOD.TRANSFER 
  },
  { 
    label: "Transfer Virtual Account", 
    value: ENUM_PLAN_PURCHASE_PAYMENT_METHOD.TRANSFER_VIRTUAL_ACCOUNT 
  },
  {
    label: "Credit/Debit Card",
    value: ENUM_PLAN_PURCHASE_PAYMENT_METHOD.GATEWAY,
  },
  {
    label: "Free",
    value: ENUM_PLAN_PURCHASE_PAYMENT_METHOD.FREE,
  }
];

export const LIST_PLAN_PURCHASE_PAYMENT_METHOD_FILTER = [
  { 
    label: "Transfer", 
    value: ENUM_PLAN_PURCHASE_PAYMENT_METHOD.TRANSFER 
  },
  { 
    label: "Transfer Virtual Account", 
    value: ENUM_PLAN_PURCHASE_PAYMENT_METHOD.TRANSFER_VIRTUAL_ACCOUNT 
  },
  {
    label: "Credit/Debit Card",
    value: ENUM_PLAN_PURCHASE_PAYMENT_METHOD.CREDIT_CARD,
  },
  {
    label: "Free",
    value: ENUM_PLAN_PURCHASE_PAYMENT_METHOD.FREE,
  }
];

export const ENUM_PLAN_PURCHASE_INVOICE_TYPE = {
  NONE: "NONE",
  TAX_INVOICE: "TAX_INVOICE",
  CASH_RECEIPT: "CASH_RECEIPT",
};

export const COLOR_PLAN_PURCHASE_INVOICE_TYPE: any = {
  [ENUM_PLAN_PURCHASE_INVOICE_TYPE.NONE]: "secondary",
  [ENUM_PLAN_PURCHASE_INVOICE_TYPE.TAX_INVOICE]: "warning",
  [ENUM_PLAN_PURCHASE_INVOICE_TYPE.CASH_RECEIPT]: "success",
};

export const LIST_PLAN_PURCHASE_INVOICE_TYPE = [
  { label: "None", value: ENUM_PLAN_PURCHASE_INVOICE_TYPE.NONE },
  { label: "Tax Invoice", value: ENUM_PLAN_PURCHASE_INVOICE_TYPE.TAX_INVOICE },
  {
    label: "Cash Receipt",
    value: ENUM_PLAN_PURCHASE_INVOICE_TYPE.CASH_RECEIPT,
  },
];

export const ENUM_USER_PLAN_PURCHASE_STATUS = {
  ACTIVE: "ACTIVE",
  PENDING: "PENDING",
  EXPIRED: "EXPERIED",
  REVOKED: "REVOKED",
};

export const COLOR_USER_PLAN_PURCHASE_STATUS: any = {
  [ENUM_USER_PLAN_PURCHASE_STATUS.ACTIVE]: "success",
  [ENUM_USER_PLAN_PURCHASE_STATUS.PENDING]: "warning",
  [ENUM_USER_PLAN_PURCHASE_STATUS.EXPIRED]: "danger",
  [ENUM_USER_PLAN_PURCHASE_STATUS.REVOKED]: "dark",
};

export const LIST_USER_PLAN_PURCHASE_STATUS = [
  { label: "Active", value: ENUM_USER_PLAN_PURCHASE_STATUS.ACTIVE },
  { label: "Pending", value: ENUM_USER_PLAN_PURCHASE_STATUS.PENDING },
  { label: "Plan Expired", value: ENUM_USER_PLAN_PURCHASE_STATUS.EXPIRED },
  { label: "Revoked", value: ENUM_USER_PLAN_PURCHASE_STATUS.REVOKED },
];

export const ENUM_PLAN_PURCHASE_PAYMENT_STATUS = {
  PENDING: "PENDING",
  SUCCEEDED: "SUCCEEDED",
  FAILED: "FAILED",
  REFUNDED: "REFUNDED",
  CANCELLED: "CANCELLED"
};

export const COLOR_PLAN_PURCHASE_PAYMENT_STATUS: any = {
  [ENUM_PLAN_PURCHASE_PAYMENT_STATUS.PENDING]: "warning",
  [ENUM_PLAN_PURCHASE_PAYMENT_STATUS.SUCCEEDED]: "primary",
  [ENUM_PLAN_PURCHASE_PAYMENT_STATUS.FAILED]: "danger",
  [ENUM_PLAN_PURCHASE_PAYMENT_STATUS.REFUNDED]: "purple",
  [ENUM_PLAN_PURCHASE_PAYMENT_STATUS.CANCELLED]: "dark",
};

export const LIST_PLAN_PURCHASE_PAYMENT_STATUS = [
  { label: "Pending", value: ENUM_PLAN_PURCHASE_PAYMENT_STATUS.PENDING },
  { label: "Paid", value: ENUM_PLAN_PURCHASE_PAYMENT_STATUS.SUCCEEDED },
  { label: "Failed", value: ENUM_PLAN_PURCHASE_PAYMENT_STATUS.FAILED },
  { label: "Refunded", value: ENUM_PLAN_PURCHASE_PAYMENT_STATUS.REFUNDED },
  { label: "Cancelled", value: ENUM_PLAN_PURCHASE_PAYMENT_STATUS.CANCELLED },
];

export const PRE_REGISTER_SOURCE_OPTION = [
  {
    label: "Unknown source",
    value: "unknown",
  },
  {
    label: "Instagram",
    value: "instagram",
  },
  {
    label: "Facebook",
    value: "facebook",
  },
  {
    label: "Tiktok",
    value: "tiktok",
  },
  {
    label: "Google",
    value: "google",
  },
  {
    label: "Naver",
    value: "naver",
  },
  {
    label: "Daum",
    value: "daum",
  },
  {
    label: "KakaoTalk",
    value: "kakaotalk",
  },
];

export const ENUM_CONTENT_TYPE = {
  COMMUNITY: 1,
  REVIEW: 2,
};

export const COLOR_CONTENT_TYPE: any = {
  [ENUM_CONTENT_TYPE.COMMUNITY]: "success",
  [ENUM_CONTENT_TYPE.REVIEW]: "info",
};

export const LIST_CONTENT_SOURCE_OPTION = [
  { label: "User Source", value: 0 },
  { label: "AI", value: 1 },
];

export const ENUM_CONTENT_AI_APPROVAL_STATUS = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
};

export const COLOR_CONTENT_AI_APPROVAL_STATUS: any = {
  [ENUM_CONTENT_AI_APPROVAL_STATUS.PENDING]: "orange",
  [ENUM_CONTENT_AI_APPROVAL_STATUS.APPROVED]: "success",
  [ENUM_CONTENT_AI_APPROVAL_STATUS.REJECTED]: "danger",
};

export const LIST_CONTENT_AI_APPROVAL_STATUS_OPTION = [
  { label: "AI Pending", value: ENUM_CONTENT_AI_APPROVAL_STATUS.PENDING },
  { label: "AI Approved", value: ENUM_CONTENT_AI_APPROVAL_STATUS.APPROVED },
  { label: "AI Rejected", value: ENUM_CONTENT_AI_APPROVAL_STATUS.REJECTED },
];

export const LIST_CONTENT_TYPE_OPTION = [
  { label: "Community", value: ENUM_CONTENT_TYPE.COMMUNITY },
  { label: "Review", value: ENUM_CONTENT_TYPE.REVIEW },
];

export const ENUM_CONTENT_CREATED_TYPE = {
  NORMAL: "normal",
  SYSTEM: "system",
};

export const COLOR_CONTENT_CREATED_TYPE: any = {
  [ENUM_CONTENT_CREATED_TYPE.NORMAL]: "primary",
  [ENUM_CONTENT_CREATED_TYPE.SYSTEM]: "danger",
};

export const LIST_CONTENT_CREATED_TYPE_OPTION = [
  { label: "Normal", value: ENUM_CONTENT_CREATED_TYPE.NORMAL },
  { label: "System", value: ENUM_CONTENT_CREATED_TYPE.SYSTEM },
];

export const ENUM_CONTENT_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
};

export const COLOR_CONTENT_STATUS: any = {
  [ENUM_CONTENT_STATUS.ACTIVE]: "success",
  [ENUM_CONTENT_STATUS.INACTIVE]: "danger",
};

export const LIST_CONTENT_STATUS_OPTION = [
  {
    label: "Active",
    value: ENUM_CONTENT_STATUS.ACTIVE,
  },
  {
    label: "Disable",
    value: ENUM_CONTENT_STATUS.INACTIVE,
  },
];
export const ENUM_NOTICE_TYPE = {
  NOTICE: "NOTICE",
  FAQ: "FAQ",
  GUIDE: "GUIDE",
  SYSTEM: "SYSTEM",
  POLICY: "POLICY",
};

export const COLOR_NOTICE_TYPE: any = {
  [ENUM_NOTICE_TYPE.NOTICE]: "success",
  [ENUM_NOTICE_TYPE.FAQ]: "warning",
  [ENUM_NOTICE_TYPE.GUIDE]: "secondary",
  [ENUM_NOTICE_TYPE.SYSTEM]: "danger",
  [ENUM_NOTICE_TYPE.POLICY]: "info",
};

export const LIST_NOTICE_TYPE = [
  {
    label: "Notice",
    value: ENUM_NOTICE_TYPE.NOTICE,
  },
  {
    label: "FAQ",
    value: ENUM_NOTICE_TYPE.FAQ,
  },
  {
    label: "Guide",
    value: ENUM_NOTICE_TYPE.GUIDE,
  },
  {
    label: "System",
    value: ENUM_NOTICE_TYPE.SYSTEM,
  },
  {
    label: "Policy",
    value: ENUM_NOTICE_TYPE.POLICY,
  },
];

export const ENUM_CASH_RECEIPT_TYPE = {
  PERSONAL: "PERSONAL",
  BUSINESS: "BUSINESS",
};

export const COLOR_CASH_RECEIPT_TYPE: any = {
  [ENUM_CASH_RECEIPT_TYPE.PERSONAL]: "info",
  [ENUM_CASH_RECEIPT_TYPE.BUSINESS]: "purple",
};

export const LIST_CASH_RECEIPT_TYPE_OPTION = [
  {
    label: "Personal",
    value: ENUM_CASH_RECEIPT_TYPE.PERSONAL,
  },
  {
    label: "Business",
    value: ENUM_CASH_RECEIPT_TYPE.BUSINESS,
  },
];

export const ENUM_GATEWAY_PAYMENT_METHOD = {
  VIRTUALACCOUNT: "VIRTUALACCOUNT",
  CREDITCARD: "CREDITCARD",
};

export const COLOR_GATEWAY_PAYMENT_METHOD: any = {
  [ENUM_GATEWAY_PAYMENT_METHOD.VIRTUALACCOUNT]: "success",
  [ENUM_GATEWAY_PAYMENT_METHOD.CREDITCARD]: "danger",
};

export const LIST_GATEWAY_PAYMENT_METHOD_OPTION = [
  {
    label: "Virtual Account",
    value: ENUM_GATEWAY_PAYMENT_METHOD.VIRTUALACCOUNT,
  },
  {
    label: "Credit Card",
    value: ENUM_GATEWAY_PAYMENT_METHOD.CREDITCARD,
  },
];

export const ENUM_PLAN_PRICE_TYPE = {
  CUSTOM: "CUSTOM",
  FREE: "FREE",
};

export const COLOR_PLAN_PRICE_TYPE: any = {
  [ENUM_PLAN_PRICE_TYPE.CUSTOM]: "warning",
  [ENUM_PLAN_PRICE_TYPE.FREE]: "success",
};

export const LIST_PLAN_PRICE_TYPE = [
  { label: "Custom Price", value: ENUM_PLAN_PRICE_TYPE.CUSTOM },
  { label: "Free Plan", value: ENUM_PLAN_PRICE_TYPE.FREE },
];

export const ENUM_AGENCY_BRANCH_STATUS = {
  LINKED: 1,
  NOT_LINK_YET: 2,
};

export const COLOR_AGENCY_BRANCH_STATUS: any = {
  [ENUM_AGENCY_BRANCH_STATUS.LINKED]: "success",
  [ENUM_AGENCY_BRANCH_STATUS.NOT_LINK_YET]: "danger",
};

export const AGENCY_BRANCH_STATUS_OPTION = [
  {
    label: "Linked",
    value: ENUM_AGENCY_BRANCH_STATUS.LINKED,
  },
  {
    label: "Not Link Yet",
    value: ENUM_AGENCY_BRANCH_STATUS.NOT_LINK_YET,
  },
];

export const ENUM_AGENCY_STATUS = {
  ACTIVATED: "ACTIVE",
  INACTIVATED: "INACTIVE",
};

export const COLOR_AGENCY_STATUS: any = {
  [ENUM_AGENCY_STATUS.ACTIVATED]: "success",
  [ENUM_AGENCY_STATUS.INACTIVATED]: "danger",
};

export const AGENCY_STATUS_OPTION = [
  { label: "Active", value: ENUM_AGENCY_STATUS.ACTIVATED },
  { label: "InActive", value: ENUM_AGENCY_STATUS.INACTIVATED },
];

// VOC Management
export const ENUM_VOC_TYPE = {
  USING_APP: 1,
  WITHDRAW_ACCOUNT: 2,
};

export const COLOR_VOC_TYPE: any = {
  [ENUM_VOC_TYPE.USING_APP]: "primary",
  [ENUM_VOC_TYPE.WITHDRAW_ACCOUNT]: "warning",
};

export const LIST_VOC_TYPE_OPTION = [
  {
    value: ENUM_VOC_TYPE.USING_APP,
    label: "Using App",
  },
  {
    value: ENUM_VOC_TYPE.WITHDRAW_ACCOUNT,
    label: "Withdraw account",
  },
];

export const ENUM_IS_REQUIRED_CONTENT = {
  REQUIRED: 1,
  NO_REQUIRED: 0,
};

export const COLOR_IS_REQUIRED_CONTENT: any = {
  [ENUM_IS_REQUIRED_CONTENT.REQUIRED]: "danger",
  [ENUM_IS_REQUIRED_CONTENT.NO_REQUIRED]: "success",
};

export const LIST_IS_REQUIRED_CONTENT_OPTION = [
  {
    value: ENUM_IS_REQUIRED_CONTENT.REQUIRED,
    label: "Required",
  },
  {
    value: ENUM_IS_REQUIRED_CONTENT.NO_REQUIRED,
    label: "Not required",
  },
];

export const LIST_SETTING_JOB_METHOD_OPTION = [
  {
    value: "app",
    label: "App",
  },
  {
    value: "web",
    label: "Web",
  },
];

export const LIST_ADULT_VERIFY_PROVIDER_OPTION = [
  {
    value: "omni-one",
    label: "Ommi-One",
  },
  {
    value: "kg-mobilians",
    label: "KG Mobilians",
  },
];

export const ENUM_ADULT_VERIFY_STATUS = {
  SUCCESS: 1,
  FAIL: 0,
};

export const COLOR_ADULT_VERIFY_STATUS: any = {
  [ENUM_ADULT_VERIFY_STATUS.SUCCESS]: "success",
  [ENUM_ADULT_VERIFY_STATUS.FAIL]: "danger",
};

export const LIST_ADULT_VERIFY_STATUS_OPTION = [
  {
    value: ENUM_ADULT_VERIFY_STATUS.SUCCESS,
    label: "Success",
  },
  {
    value: ENUM_ADULT_VERIFY_STATUS.FAIL,
    label: "Fail",
  },
];

export const INQUIRY_TYPE = [
  {
    label: "Report Bug",
    value: 1,
  },
  {
    label: "Account Issue",
    value: 2,
  },
  {
    label: "Service Inquiry",
    value: 3,
  },
  {
    label: "Payment Refund",
    value: 4,
  },
  {
    label: "Complaint",
    value: 5,
  },
];

export const COLOR_INQUIRY_TYPE: any = {
  [1]: "danger",
  [2]: "secondary",
  [3]: "success",
  [4]: "primary",
  [5]: "warning",
};

export const INQUIRY_STATUS = [
  {
    label: "Pending",
    value: 1,
  },
  {
    label: "In-Progress",
    value: 2,
  },
  {
    label: "Resolved",
    value: 3,
  },
  {
    label: "Closed",
    value: 4,
  },
];

export const COLOR_INQUIRY_STATUS: any = {
  [1]: "warning",
  [2]: "primary",
  [3]: "success",
  [4]: "danger",
};

export const HEXCOLOR_INQUIRY_STATUS: any = {
  [1]: "#ffc107",
  [2]: "#007bff",
  [3]: "#28a745",
  [4]: "#dc3545",
};

export const INQUIRY_REPLY_TYPE = [
  {
    label: "User",
    value: 1,
  },
  {
    label: "Admin",
    value: 2,
  },
];

export const INQUIRY_ATTACHMENT_TYPE = [
  {
    label: "Pending",
    value: 1,
  },
  {
    label: "In-Progress",
    value: 2,
  },
  {
    label: "Resolved",
    value: 3,
  },
];

export const COLOR_LIST_COMMENT_SOURCE: any = {
  ["real"]: "warning",
  ["ai"]: "primary",
};

export const LIST_COMMENT_SOURCE_OPTION = [
  { label: "Real", value: "real" },
  { label: "AI", value: "ai" },
];

export const COLOR_LIST_TYPE_COMMENT: any = {
  ["real"]: "info",
  ["system"]: "danger",
};

export const LIST_TYPE_COMMENT_OPTION = [
  {
    value: "real",
    label: "From User",
  },
  {
    value: "system",
    label: "From System",
  },
];

export const ENUM_CONTENT_COMMENT_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  DELETED: "DELETED",
};

export const COLOR_CONTENT_COMMENT_STATUS: any = {
  [ENUM_CONTENT_COMMENT_STATUS.ACTIVE]: "success",
  [ENUM_CONTENT_COMMENT_STATUS.INACTIVE]: "warning",
  [ENUM_CONTENT_COMMENT_STATUS.DELETED]: "danger",
};

export const LIST_CONTENT_COMMENT_STATUS_OPTION = [
  {
    label: "Active",
    value: ENUM_CONTENT_COMMENT_STATUS.ACTIVE,
  },
  {
    label: "InActive",
    value: ENUM_CONTENT_COMMENT_STATUS.INACTIVE,
  },
  {
    label: "Deleted",
    value: ENUM_CONTENT_COMMENT_STATUS.DELETED,
  },
];


export const USER_NOTIFICATION_ALLOW_TYPE_OPTION = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "Connect",
    value: "connect",
  },
  {
    label: "Comment",
    value: "comment",
  },
  {
    label: "Message",
    value: "message",
  },
  {
    label: "Like",
    value: "like",
  },
  {
    label: "Share",
    value: "share",
  },
  {
    label: "Promotion Event",
    value: "promotion_event",
  },
  {
    label: "Inquiry",
    value: "inquiry",
  },
];

export const ENUM_TALENT_USER_TYPE = {
  MEMBER: "member",
  NON_MEMBER: "non-member",
  SYSTEM: "system",
};

export const COLOR_TALENT_USER_TYPE: any = {
  [ENUM_TALENT_USER_TYPE.MEMBER]: "info",
  [ENUM_TALENT_USER_TYPE.NON_MEMBER]: "warning",
  [ENUM_TALENT_USER_TYPE.SYSTEM]: "danger",
};

export const LIST_TALENT_USER_TYPE_OPTION = [
  {
    label: "Member",
    value: ENUM_TALENT_USER_TYPE.MEMBER,
  },
  {
    label: "Non-Member",
    value: ENUM_TALENT_USER_TYPE.NON_MEMBER,
  },
  {
    label: "System",
    value: ENUM_TALENT_USER_TYPE.SYSTEM,
  },
];

export const CON_WORKING_DAYS = [
  {
    label: "Specify days",
    value: false,
  },
  {
    label: "Negotiation",
    value: true,
  },
];

export const CON_WORKING_TIME = [
  {
    label: "Specify time",
    value: false,
  },
  {
    label: "Negotiation",
    value: true,
  },
];

export const CON_WORKING_SALARY = [
  {
    label: "Specify amount",
    value: false,
  },
  {
    label: "Negotiation",
    value: true,
  },
];

export const CON_WORKING_DAY_OF_WEEK = [
  { value: 1, label: "MON" },
  { value: 2, label: "TUE" },
  { value: 3, label: "WED" },
  { value: 4, label: "THU" },
  { value: 5, label: "FRI" },
  { value: 6, label: "SAT" },
  { value: 7, label: "SUN" },
];

export const LIST_OPTION_AI_SETTING_TARGET_RANGE = [
  { label: "3 days", value: 3 },
  { label: "7 days", value: 7 },
  { label: "10 days", value: 10 }
];

export const ENUM_SOURCE_CREATOR = {
  REAL_USER: "REAL_USER",
  SYSTEM: "SYSTEM",
};

export const COLOR_SOURCE_CREATOR: any = {
  [ENUM_SOURCE_CREATOR.REAL_USER]: "blue",
  [ENUM_SOURCE_CREATOR.SYSTEM]: "danger",
};

export const LIST_OPTION_SOURCE_CREATOR = [
  { label: "Real User", value: ENUM_SOURCE_CREATOR.REAL_USER },
  { label: "System", value: ENUM_SOURCE_CREATOR.SYSTEM },
];

export const ENUM_SOURCE_CHANNEL = {
  APP: "APP",
  WEB: "WEB",
  CONSOLE: "CONSOLE",
};

export const COLOR_SOURCE_CHANNEL: any = {
  [ENUM_SOURCE_CHANNEL.APP]: "purple",
  [ENUM_SOURCE_CHANNEL.WEB]: "success",
  [ENUM_SOURCE_CHANNEL.CONSOLE]: "warning",
};

export const LIST_OPTION_SOURCE_CHANNEL = [
  { label: "App", value: ENUM_SOURCE_CHANNEL.APP },
  { label: "Web", value: ENUM_SOURCE_CHANNEL.WEB },
  { label: "Console", value: ENUM_SOURCE_CHANNEL.CONSOLE },
];

export const ENUM_SECTION_ITEM_TYPE = {
  MANUAL: "MANUAL",
  PAYMENT: "PAYMENT",
};

export const COLOR_SECTION_ITEM_TYPE: any = {
  [ENUM_SECTION_ITEM_TYPE.MANUAL]: "purple",
  [ENUM_SECTION_ITEM_TYPE.PAYMENT]: "warning",
};

export const LIST_OPTION_SECTION_ITEM_TYPE = [
  { label: "Payment", value: ENUM_SECTION_ITEM_TYPE.PAYMENT },
  { label: "Manual", value: ENUM_SECTION_ITEM_TYPE.MANUAL },
];

export const ENUM_BANNER_VISIBLE_MENU = {
  STORE_REVIEW_DETAIL: "store_review_detail",
  COMMUNITY_DETAIL: "community_detail",
  FAQ_DETAIL: "faq_detail",
  COMMUNITY: "community",
  JOB_POST: "jobpost",
};

export const COLOR_BANNER_VISIBLE_MENU: any = {
  [ENUM_BANNER_VISIBLE_MENU.STORE_REVIEW_DETAIL]: "purple",
  [ENUM_BANNER_VISIBLE_MENU.COMMUNITY_DETAIL]: "success",
  [ENUM_BANNER_VISIBLE_MENU.FAQ_DETAIL]: "primary",
  [ENUM_BANNER_VISIBLE_MENU.COMMUNITY]: "info",
  [ENUM_BANNER_VISIBLE_MENU.JOB_POST]: "warning",
};

export const LIST_OPTION_BANNER_VISIBLE_MENU = [
  { label: "Store Review Detail", value: ENUM_BANNER_VISIBLE_MENU.STORE_REVIEW_DETAIL },
  { label: "Community Detail", value: ENUM_BANNER_VISIBLE_MENU.COMMUNITY_DETAIL },
  { label: "FAQ Detail", value: ENUM_BANNER_VISIBLE_MENU.FAQ_DETAIL },
  { label: "Community", value: ENUM_BANNER_VISIBLE_MENU.COMMUNITY },
  { label: "Job Post", value: ENUM_BANNER_VISIBLE_MENU.JOB_POST },
];

export const LIST_OPTION_PREMIUM_BANNER_PLACEMENT = [
  { label: "Top of Home", value: "top_home" },
  { label: "Top of Community", value: "top_community" },
  { label: "Middle of Community Detail", value: "middle_community_detail" }
];

export const LIST_OPTION_ADDITIONAL_SECTION_EXPOSURE = [
  { label: "Featured Job Section", value: "Featured Job Section" },
  { label: "Recommended by AI", value: "Recommended by AI" },
  { label: "Location-based Highlight", value: "Location-based Highlight" },
  { label: "TOP Section", value: "TOP Section" }
];

export const ENUM_POPUP_DISPLAY_SCREEN = {
  HOME: "home",
  // JOB_POSTING: "job_posting",
  POST_MANAGEMENT: "job-post",
  FIND_TALENT: "find-talent",
  COMMUNITY: "community",
  CHAT: "chat",
};

export const POPUP_DISPLAY_SCREEN_OPTION = [
  { label: "Home", value: ENUM_POPUP_DISPLAY_SCREEN.HOME },
  // { label: "Job Posting", value: ENUM_POPUP_DISPLAY_SCREEN.JOB_POSTING },
  { label: "Post Management", value: ENUM_POPUP_DISPLAY_SCREEN.POST_MANAGEMENT },
  { label: "Find Talent", value: ENUM_POPUP_DISPLAY_SCREEN.FIND_TALENT },
  { label: "Community", value: ENUM_POPUP_DISPLAY_SCREEN.COMMUNITY },
  { label: "Chat", value: ENUM_POPUP_DISPLAY_SCREEN.CHAT },
];

export const ENUM_POPUP_STATUS = {
  DISPLAY_OFF: 0,
  DISPLAY_ON: 1,
};

export const COLOR_POPUP_STATUS: any = {
  [ENUM_POPUP_STATUS.DISPLAY_OFF]: "primary",
  [ENUM_POPUP_STATUS.DISPLAY_ON]: "danger"
};

export const POPUP_STATUS_OPTION = [
  { label: "노출 ON", value: ENUM_POPUP_STATUS.DISPLAY_ON },
  { label: "노출 OFF", value: ENUM_POPUP_STATUS.DISPLAY_OFF },
];